<div class="contentItemMain">
    <a [routerLink]="['/' + languageCode, 'content', id]" [queryParams]="{ dt: 1 }">
        <img src="{{localImageLocation}}Arrows_12x16_CCC.png" alt="{{title}}"/>
    </a>
    <div class="contentItem">
        <a [routerLink]="[languageCode, '/content', id]" [queryParams]="{ dt: 1 }" class="contentLink">{{title}}</a>
        <p *ngIf="description !== ''">&nbsp;-&nbsp;{{description}}</p>
    </div>
</div>
